package com.eladfinish.bible.contest.screens.search.usecases.specialSearch

import com.eladfinish.bible.contest.screens.search.model.ChapterDetails
import com.eladfinish.bible.contest.utils.addGershaim

/**
 * Developed by
 * @author Elad Finish
 */

class VersesPerChapters : SpecialSearch {

    private val sb = StringBuilder()

    private var counter = 0

    override fun process(chapterDetails: ChapterDetails): Unit = with(chapterDetails) {
        counter++
        sb.append("$counter) ")
            .append("$bookName ${chapterName.addGershaim()}: ${verses.size}")
            .append("\n")
    }

    override fun getSummary(): String =
        sb.toString()
}
